import { Component } from '@angular/core';
import { AuthService } from '../../services/services';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';

  constructor(public auth: AuthService) {
    auth.handleAuthentication();
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/src/app/components/app/app.component.ts